const byHover = (OBJECTS = undefined) => {
  if (OBJECTS === undefined) {
    throw new Error('Cannot create reducer, missing arguments');
  }

  return (state = { hovered: -1 }, { type, id }) => {
    switch (type) {
      case `${OBJECTS}_HOVERED`:
        return {
          ...state,
          hovered: id,
        };
      default:
        return state;
    }
  };
};

export default byHover;

/**
 * Selectors
 */
export const getHovered = state => (state ? state.hovered : -1);



// WEBPACK FOOTER //
// ./app/src/state/reducers/byHover.js